import { useOrgFeatureFlags } from '@frontend/get-org-data';

export const useAIReceptionistSettingsFeatureFlag = () => {
  const { getFeatureFlagAllEnabled } = useOrgFeatureFlags();
  return getFeatureFlagAllEnabled('nwx:fusion-messaging-settings');
};
